import Vue from 'vue';

import Element from 'element-ui';
import '../styles/_element-override.scss';
import '../styles/themes/theme/index.css';
import locale from 'element-ui/lib/locale/lang/en';

// Styles
import '../styles/main.scss';
import '../styles/utils.scss';
import '../styles/custom.scss';

Vue.use(Element, { locale });
